import apiDateToDateTime from './apiDateToDateTime';

// https://moment.github.io/luxon/#/

type Variant = 'short' | 'long' | 'month';

/**
 *
 * See: https://www.notion.so/teamhologram/Hologram-Writing-Guide-d85fbb8709e64fdc84374b76f937b566?pvs=4#c177d10d80d741d990c8fa761c6ba49e
 * And: https://www.notion.so/teamhologram/Hologram-Writing-Guide-d85fbb8709e64fdc84374b76f937b566?pvs=4#97171cc3105a4b089d564a717bc25bed
 */
const formatDate = (rawDate?: string, variant: Variant = 'short') => {
  if (!rawDate) {
    return undefined;
  }

  const internalDate = apiDateToDateTime(rawDate);

  if (!internalDate) {
    return undefined;
  }

  switch (variant) {
    case 'short':
      return internalDate.toFormat('MM-dd-yy');

    case 'month':
      return internalDate.toFormat('LLLL yyyy');

    case 'long':
    default:
      return internalDate.toFormat('MMM d, yyyy');
  }
};

export default formatDate;
